export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-14.de9a7194.svg";